import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { useUrlResolver } from "~/components/Navigation/useUrlResolver";
import { ControlledTabsContainer, TabItem } from "~/primitiveComponents/navigation/Tabs/index";
export type Tabs = "overview" | "settings";
interface EphemeralEnvironmentsTabsProps {
    project: ProjectResource;
    currentTab: Tabs;
}
export default function EphemeralEnvironmentsTabs({ project, currentTab }: EphemeralEnvironmentsTabsProps) {
    const urlResolver = useUrlResolver();
    const navigation = useSpaceAwareNavigation();
    const ephemeralEnvironmentsPageUrl = urlResolver.resolve(links.ephemeralEnvironmentsPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }));
    const ephemeralEnvironmentsSettingsPageUrl = urlResolver.resolve(links.ephemeralEnvironmentsSettingsPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }));
    const activeLink = currentTab === "overview" ? ephemeralEnvironmentsPageUrl : ephemeralEnvironmentsSettingsPageUrl;
    return (<ControlledTabsContainer value={activeLink} onChange={(link) => navigation.navigate(link)}>
            <TabItem key={"overview"} label={"Overview"} value={ephemeralEnvironmentsPageUrl}/>
            <TabItem key={"settings"} label={"Settings"} value={ephemeralEnvironmentsSettingsPageUrl}/>
        </ControlledTabsContainer>);
}
